import React, { RefObject, useState } from 'react';

const useLayoutDragHook = (tabRef : RefObject<HTMLUListElement>) => {
  const [scrollMouse, setScrollMouse] = useState({ drag: false, down: false, initialMousePos: 0, scrollLeft: 0 });

  const tabScroll = (e: React.MouseEvent) => {
    // How far the mouse has been moved
    const dx = e.clientX - scrollMouse.initialMousePos;
    // Scroll the element
    if (tabRef.current) {
      tabRef.current.scrollLeft = scrollMouse.scrollLeft - dx;
    }
  };

  const scrollTabIntoView = (tabEl) => {
    tabEl.currentTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  };

  const mouseDown = (e: React.MouseEvent) => {
    const target = e.currentTarget as HTMLElement;
    setScrollMouse((prev) => ({
      ...prev,
      down: true,
      initialMousePos: e.clientX,
      scrollLeft: target.scrollLeft,
    }));
  };

  const mouseUp = (e: React.MouseEvent) => {
    setScrollMouse((prev) => ({
      ...prev,
      down: false,
    }));

    // Calculating if the mouse drags accidentally with a range of 10 pixels both to left and right.
    const hasDragToRight = scrollMouse.initialMousePos + 10 > e.clientX;
    const hasDragToLeft = scrollMouse.initialMousePos - 10 < e.clientX;

    // If it drags, then use the timeout to prevent click, if not, disabling drag.
    if (!hasDragToRight || !hasDragToLeft) {
      // Timeout drag flag in order to prevent click event
      setTimeout(() => {
        setScrollMouse((prev) => ({
          ...prev,
          drag: false,
        }));
      }, 0);
    } else {
      setScrollMouse((prev) => ({
        ...prev,
        drag: false,
      }));
    }
  };

  const mouseMove = (e: React.MouseEvent) => {
    // Call only while dragging (mouseDown + mouseMove = drag)
    if (scrollMouse.down) {
      setScrollMouse((prev) => ({
        ...prev,
        drag: true,
      }));
      tabScroll(e);
    }
  };

  return { scrollMouse, mouseDown, mouseUp, mouseMove, scrollTabIntoView };
};

export default useLayoutDragHook;
